/* oxlint-disable typescript/no-explicit-any -- attributes can be any type */
// Parse attribute string into key-value pairs
// Supports:
//   key="string" | key=123 | key=true | key=false | key=`
//   key:="json string"  -> any string: quotes, braces and line breaks escaped as in JSON
//   #id        -> id="..."     (last one wins, per spec)
//   .class     -> class="..."  (multiple classes space-joined)
// Example: '#intro .big .bold width=100'
// Returns: { id: "intro", class: "big bold", width: 100 }

export function parseAttributes(str: string): Record<string, any> {
  const attrs: Record<string, any> = {}
  if (!str) return attrs

  const classes: string[] = []

  // Matches, in order:
  //  1. #identifier
  //  2. .identifier
  //  3. key:="json string"
  //  4. key="string" | key=number | key=true|false | key=`
  const regex =
    /#([a-zA-Z0-9_][\w-]*)|\.([a-zA-Z_][\w-]*)|(\w+):=("(?:[^"\\]|\\.)*")|(\w+)=((?:"[^"]*")|(?:\d+)|(?:true|false)|(?:`))/g
  let match

  while ((match = regex.exec(str)) !== null) {
    if (match[1] !== undefined) {
      attrs.id = match[1]
      continue
    }
    if (match[2] !== undefined) {
      classes.push(match[2])
      continue
    }

    if (match[3] !== undefined) {
      attrs[match[3]] = JSON.parse(match[4])
      continue
    }

    const key = match[5]
    let value: any = match[6]

    if (value === 'true') value = true
    else if (value === 'false') value = false
    else if (value === '`') value = undefined
    else if (value.startsWith('"') && value.endsWith('"'))
      value = value.slice(1, -1)
    else if (/^\d+$/.test(value)) value = Math.trunc(Number(value))

    attrs[key] = value
  }

  if (classes.length > 0) attrs.class = classes.join(' ')

  return attrs
}
